import { BigNumberish, constants } from 'ethers';
import { Original } from 'components/common';

export interface Map {
  [key: string]: string | undefined;
}
export interface Attributes {
  title: string;
  description: string;
  image_url: string;
  token_id?: string;
  [key: string]: any;
}

export interface TokenContract {
  address: string;
  network_id: number;
  symbol: string; // useless for these
  token_type: 'ERC721' | 'ERC1155';
}

export interface ItemImage {
  original?: string;
  cid?: string;
  tiny?: string;
  thumb?: string;
  full?: string;
}

export interface ItemMedia {
  image?: ItemImage;
}

export interface Item {
  id: string;
  item_type_id: string;
  token_id: string;
  token_status: string;
  attributes: Attributes;
  media: ItemMedia;
  collection_id: string;
  locked: boolean;
  max_supply?: string;
  royalty_info?: RoyaltyInfo;
}

interface RoyaltyInfo {
  receiver: string;
  amount_bps: number;
}

export interface PublicItem {
  id: string;
  token_id: string;
  attributes: Attributes;
  media: ItemMedia;
  collection_id: string;
  token_type: 'ERC721' | 'ERC1155';
  network_id: number;
  contract_address?: string;
}

export type Token = {
  kind: BigNumberish;
  token: string;
  id: BigNumberish;
  amount: BigNumberish;
};

export interface Order {
  expiry: BigNumberish;
  nonce: BigNumberish;
  makerAddress: string;
  takerAddress: string;
  makerToken: Token;
  takerToken: Token;
  payoutTo: string[];
  payoutAmount: BigNumberish[];
}

export interface ERC20Token {
  address: string;
  decimals: number;
  symbol: string;
}

export interface FiatProviders {
  stripe: any;
}

export enum TokenKinds {
  ERC721 = 0,
  ERC1155 = 1,
  ERC20 = 2,
  ETH = 3,
}

export const tokenKinds = {
  ERC20: TokenKinds.ERC20,
  ERC721: TokenKinds.ERC721,
  ERC1155: TokenKinds.ERC1155,
  ETH: TokenKinds.ETH,
};

export const emptyToken: Token = {
  kind: tokenKinds.ERC20,
  token: constants.AddressZero,
  amount: '0',
  id: '0',
};

export enum Polling {
  fast = 8000,
  average = 15000,
  slow = 30000,
}

export interface OwnedItem {
  quantity: number;
  item: PublicItem;
}

export interface CollectionItem extends PublicItem {
  quantity: number;
  collectionName: string;
  link: {
    url: string;
    target: string;
  };
  isPrint: boolean;
  original?: Original;
}

export interface CollectionFilterItem {
  name: string;
  attributes: Array<CollectionAttributes>;
}

export interface CollectionAttributes {
  count: number;
  name: string;
  values: AttributeStats[];
}

export interface AttributeStats {
  count: number;
  name: string;
}

export type Attribute = {
  name: string;
  value: string;
};

export interface Palette {
  name: string;
  layers: string[];
  description: string;
}

// TODO: actually type out the futura attributes rather than using any
export interface MixSpecs {
  attributes: any;
  pieceData: any; // actual type: PieceData (not exported from EBF utils)
  palette: Palette;
}

// paginated response type used in both v3 APIs and indexer API
export interface ApiPaginatedResults<T> {
  cursor: string | null;
  has_more: boolean;
  results: T[];
  total_results: number;
}

// types returned by indexer API
export interface NftMetadata {
  attributes: any;
  image: string;
  name: string;
}

export interface OwnedNft {
  contract_address: string;
  owner: string;
  metadata?: NftMetadata;
  quantity: string;
  token_id: string;
  chain: number;
}

export interface TokenOwnership {
  item_id: string;
  collection_id: string;
  organization_id: string;
  token_id: string;
  token_type: 'ERC721' | 'ERC1155';
  network_id: number;
  contract_address: string;
  owner: string;
  quantity: number;
  attributes: Record<string, any>;
  media: ItemMedia;
}
